import { Component, OnInit, OnDestroy, Input, Output } from '@angular/core';
import { GeneralService } from 'src/app/shared/services/general.service';
import { RequestStatus } from '../../models/requestStatus';

@Component({
    selector: 'request-item',
    templateUrl: './request-item.component.html',
    styleUrls: ['./request-item.component.scss']
})
export class RequestItemComponent implements OnInit, OnDestroy {

    @Input() item :any;
    @Input() class :any = '';
    @Input() last :any = false;
    @Input() template :any = false;
    @Output() callback :any;

    requestType:any = {};
    requestStatus:any = {};

    iconStatus:any = new RequestStatus().getIcons();

    constructor(
        protected gs: GeneralService
    ) {

        this.requestType = this.gs.getRequestTypes();
        this.requestStatus = this.gs.getRequestStatus();
        
    }
    
    ngOnInit() { 
        this.item = this.adjustItem(this.item);
    }

    ngOnDestroy(){
    }

    imgDidLoad(event){
        this.gs.imgDidLoad(event);
    }

    adjustItem(item:any){
        if(item?.ad_cover || item?.cover){
            item.cover = typeof item?.cover === 'string'? JSON.parse(item.cover) : (typeof item?.ad_cover === 'string'? JSON.parse(item.ad_cover) : (item?.ad_cover || item?.cover));          
            item.cover = this.gs.getAvatarFile(item.cover);
        }

        if(typeof item?.creator_avatar === 'string' && item?.creator_avatar!='{}')
            item.creatorFiles = this.gs.getAvatarFile(JSON.parse(item.creator_avatar));
        
        if(typeof item?.owner_avatar === 'string' && item?.owner_avatar!='{}')
            item.ownerFiles = this.gs.getAvatarFile((item.owner_avatar));
        
        if(typeof item?.payload === 'string' && item?.payload!='{}')
            item.payload = JSON.parse(item.payload);

        return item;
    }

    imageError(ev, data){
        data.avatarError = true;
      }
    
}
